import { FormattedMessage } from "react-intl";
import {
  ADMIN_COMPANIES_ROUTE,
  ADMIN_PEOPLE_ROUTE,
  ADMIN_REPORTS_ROUTE,
  ADMIN_SETTINGS_ROUTE,
  ADMIN_LOYALTY_ROUTE,
  PROGRAM_ROUTE,
  PROFILE_ROUTE,
  HOME_ROUTE,
  PEOPLE_ROUTE,
  SAFETY_ROUTE,
  PAYMENT_ROUTE,
  LOYALTY_ROUTE,
  POLICY_ROUTE,
  REPORTS_ROUTE,
  SETTINGS_ROUTE,
  AIRLINEPROGRAMS_ROUTE,
  DISCOUNTS_ROUTE,
  AADVANTAGE_PASS_ROUTE,
  PROMOTIONS_ROUTE,
} from "../../constants/routes";
import { ReactComponent as ProgramSvg } from '../../resources/images/program.svg';
import { ReactComponent as CompaniesSvg } from '../../resources/images/companies.svg';
import { ReactComponent as HomeSvg } from '../../resources/images/home.svg';
import { ReactComponent as PeopleSvg } from '../../resources/images/people.svg';
import { ReactComponent as ReportsSvg } from '../../resources/images/reports.svg';
import { ReactComponent as PolicySvg } from '../../resources/images/aa-policy.svg';
import { ReactComponent as PaymentSvg } from '../../resources/images/aa-payment.svg';
import { ReactComponent as SettingsSvg } from '../../resources/images/settings.svg';
import { ReactComponent as SafetySvg } from '../../resources/images/safety.svg';
import { ReactComponent as DiscountsSvg } from '../../resources/images/aa-discounts.svg';
import { ReactComponent as LoyaltySvg } from '../../resources/images/loyalty.svg';
import { ReactComponent as JoinSvg } from '../../resources/images/join.svg';
import { ReactComponent as AAdvantagePassSvg } from '../../resources/images/ticket-icon.svg';

export const navigationLinks = {
  AA: {
    adminNavigationItems: [
      {
        icon: <CompaniesSvg />,
        name: <FormattedMessage id="navigation.companies" />,
        route: ADMIN_COMPANIES_ROUTE,
        testId: 'companiesLink',
        permission: 'F_VIEW_PROVIDER_COMPANIES',
        disabledIfMaintenance: true,
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="admin.navigation.people" />,
        route: ADMIN_PEOPLE_ROUTE,
        testId: 'peopleLink',
        permission: 'F_VIEW_PROVIDER_USERS',
        disabledIfMaintenance: true,
      },
      {
        icon: <LoyaltySvg />,
        name: <FormattedMessage id="navigation.admin.loyalty" />,
        route: ADMIN_LOYALTY_ROUTE,
        testId: 'adminloyaltylink',
        permission: 'F_LEP_PROVIDERADMIN_VIEW',
        disabledIfMaintenance: true,
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: ADMIN_SETTINGS_ROUTE,
        testId: 'adminsettingslink',
        permission: 'F_PROVIDER_SETTINGS',
        disabledIfMaintenance: false,
      },
    ],
    navigationItems: [
      {
        icon: <ProgramSvg />,
        name: <FormattedMessage id="navigation.program" />,
        route: PROGRAM_ROUTE,
        testId: 'homeLink',
        permission: '',
      },
      {
        icon: <HomeSvg />,
        name: <FormattedMessage id="navigation.home" />,
        route: HOME_ROUTE,
        testId: 'programlink',
        permission: 'F_VIEW_COMPANYPROGRAM',
      },
      {
        icon: <PeopleSvg />,

        name: <FormattedMessage id="navigation.profile" />,
        route: PROFILE_ROUTE,
        testId: 'profilelink',
        permission: 'F_VIEW_MYPROFILE',
      },
      {
        icon: <PeopleSvg />,

        name: <FormattedMessage id="navigation.people" />,
        route: PEOPLE_ROUTE,
        testId: 'peoplelink',
        permission: 'F_VIEW_USERS',
      },
      {
        icon: <SafetySvg />,
        name: <FormattedMessage id="navigation.safety" />,
        route: SAFETY_ROUTE,
        testId: 'safetylink',
        permission: 'F_VIEW_TRIPBOARD',
      },
      {
        icon: <PolicySvg />,
        name: <FormattedMessage id="navigation.policy" />,
        route: POLICY_ROUTE,
        testId: 'policylink',
        permission: 'F_VIEW_POLICIES',
      },
      {
        icon: <PaymentSvg />,

        name: <FormattedMessage id="navigation.payment" />,
        route: PAYMENT_ROUTE,
        testId: 'paymentlink',
        permission: 'F_VIEW_PAYMENTS',
        badge: true,
      },
      {
        icon: <LoyaltySvg />,

        name: <FormattedMessage id="navigation.loyalty" />,
        route: LOYALTY_ROUTE,
        testId: 'loyaltylink',
        permission: 'F_LEP_COMPANY_VIEW',
      },
      {
        icon: <DiscountsSvg />,
        name: <FormattedMessage id="navigation.discounts" />,
        route: DISCOUNTS_ROUTE,
        testId: 'discountslink',
        permission: 'F_DISCOUNTTIER_VIEWTIERLEVEL',
      },
      {
        icon: <AAdvantagePassSvg />,
        name: <FormattedMessage id="navigation.aadvantagePass" />,
        route: AADVANTAGE_PASS_ROUTE,
        testId: 'aadvantagepasslink',
        permission: 'F_AADVANTAGE_PASS_VIEW',
      },
      {
        icon: <DiscountsSvg />,
        name: <FormattedMessage id="navigation.promotions" />,
        route: PROMOTIONS_ROUTE,
        testId: 'promotionslink',
        permission: 'F_VIEW_PROMOTIONS',
      },
      {
        icon: <ReportsSvg />,
        name: <FormattedMessage id="navigation.reports" />,
        route: REPORTS_ROUTE,
        testId: 'reportslink',
        permission: 'F_VIEW_REPORTS',
      },
      {
        icon: <SettingsSvg />,

        name: <FormattedMessage id="navigation.settings" />,
        route: SETTINGS_ROUTE,
        testId: 'settingslink',
        permission: 'F_VIEW_COMPANYSETTINGS',
      },
    ],
  },
  UC: {
    adminNavigationItems: [
      {
        icon: <CompaniesSvg />,
        name: <FormattedMessage id="navigation.companies" />,
        route: ADMIN_COMPANIES_ROUTE,
        testId: 'companiesLink',
        permission: 'F_VIEW_PROVIDER_COMPANIES',
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: ADMIN_SETTINGS_ROUTE,
        testId: 'adminsettingslink',
        permission: 'F_PROVIDER_SETTINGS',
        disabledIfMaintenance: false,
      },
    ],
    navigationItems: [
      {
        icon: <ProgramSvg />,
        name: <FormattedMessage id="navigation.program" />,
        route: PROGRAM_ROUTE,
        testId: 'homeLink',
        permission: '',
      },
      {
        icon: <HomeSvg />,
        name: <FormattedMessage id="navigation.home" />,
        route: HOME_ROUTE,
        testId: 'programlink',
        permission: 'F_VIEW_COMPANYPROGRAM',
      },
      {
        icon: <PeopleSvg />,

        name: <FormattedMessage id="navigation.profile" />,
        route: PROFILE_ROUTE,
        testId: 'profilelink',
        permission: 'F_VIEW_MYPROFILE',
      },
      {
        icon: <PeopleSvg />,

        name: <FormattedMessage id="navigation.people" />,
        route: PEOPLE_ROUTE,
        testId: 'peoplelink',
        permission: 'F_VIEW_USERS',
      },
      {
        icon: <JoinSvg />,

        name: <FormattedMessage id="navigation.join" />,
        route: AIRLINEPROGRAMS_ROUTE,
        testId: 'joinlink',
        permission: 'F_VIEW_USERDASHBOARD_AVAILABLEPROVIDERS',
      },
      {
        icon: <SafetySvg />,
        name: <FormattedMessage id="navigation.safety" />,
        route: SAFETY_ROUTE,
        testId: 'safetylink',
        permission: 'F_VIEW_TRIPBOARD',
      },
      {
        icon: <ReportsSvg />,

        name: <FormattedMessage id="navigation.reports" />,
        route: REPORTS_ROUTE,
        testId: 'reportslink',
        permission: 'F_VIEW_REPORTS',
      },
      {
        icon: <SettingsSvg />,

        name: <FormattedMessage id="navigation.settings" />,
        route: SETTINGS_ROUTE,
        testId: 'settingslink',
        permission: 'F_VIEW_COMPANYSETTINGS',
      },
    ],
  },
  AS: {
    adminNavigationItems: [
      {
        icon: <CompaniesSvg />,
        name: <FormattedMessage id="navigation.companies" />,
        route: ADMIN_COMPANIES_ROUTE,
        testId: 'companiesLink',
        permission: 'F_VIEW_PROVIDER_COMPANIES',
        disabledIfMaintenance: true,
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="admin.navigation.people" />,
        route: ADMIN_PEOPLE_ROUTE,
        testId: 'peopleLink',
        permission: 'F_VIEW_PROVIDER_USERS',
        disabledIfMaintenance: true,
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: ADMIN_SETTINGS_ROUTE,
        testId: 'adminsettingslink',
        permission: 'F_PROVIDER_SETTINGS',
        disabledIfMaintenance: false,
      },
    ],
    navigationItems: [
      {
        icon: <ProgramSvg />,
        name: <FormattedMessage id="navigation.program" />,
        route: PROGRAM_ROUTE,
        testId: 'homeLink',
        permission: '',
      },
      {
        icon: <HomeSvg />,
        name: <FormattedMessage id="navigation.home" />,
        route: HOME_ROUTE,
        testId: 'programlink',
        permission: 'F_VIEW_COMPANYPROGRAM',
      },
      {
        icon: <PeopleSvg />,

        name: <FormattedMessage id="navigation.profile" />,
        route: PROFILE_ROUTE,
        testId: 'profilelink',
        permission: 'F_VIEW_MYPROFILE',
      },
      {
        icon: <PeopleSvg />,

        name: <FormattedMessage id="navigation.people" />,
        route: PEOPLE_ROUTE,
        testId: 'peoplelink',
        permission: 'F_VIEW_USERS',
      },
      {
        icon: <SafetySvg />,
        name: <FormattedMessage id="navigation.safety" />,
        route: SAFETY_ROUTE,
        testId: 'safetylink',
        permission: 'F_VIEW_TRIPBOARD',
      },
      {
        icon: <PolicySvg />,
        name: <FormattedMessage id="navigation.policy" />,
        route: POLICY_ROUTE,
        testId: 'policylink',
        permission: 'F_VIEW_POLICIES',
      },
      {
        icon: <PaymentSvg />,
        name: <FormattedMessage id="navigation.payment" />,
        route: PAYMENT_ROUTE,
        testId: 'paymentlink',
        permission: 'F_VIEW_PAYMENTS',
      },
      {
        icon: <ReportsSvg />,
        name: <FormattedMessage id="navigation.reports" />,
        route: REPORTS_ROUTE,
        testId: 'reportslink',
        permission: 'F_VIEW_REPORTS',
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: SETTINGS_ROUTE,
        testId: 'settingslink',
        permission: 'F_VIEW_COMPANYSETTINGS',
      },
    ],
  },
  CHOICE: {
    adminNavigationItems: [
      {
        icon: <CompaniesSvg />,
        name: <FormattedMessage id="navigation.companies" />,
        route: ADMIN_COMPANIES_ROUTE,
        testId: 'companiesLink',
        permission: 'F_VIEW_PROVIDER_COMPANIES',
        disabledIfMaintenance: true,
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="admin.navigation.people" />,
        route: ADMIN_PEOPLE_ROUTE,
        testId: 'peopleLink',
        permission: 'F_VIEW_PROVIDER_USERS',
        disabledIfMaintenance: true,
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: ADMIN_SETTINGS_ROUTE,
        testId: 'adminsettingslink',
        permission: 'F_PROVIDER_SETTINGS',
        disabledIfMaintenance: false,
      },
    ],
    navigationItems: [
      {
        icon: <ProgramSvg />,
        name: <FormattedMessage id="navigation.program" />,
        route: PROGRAM_ROUTE,
        testId: 'homeLink',
        permission: '',
      },
      {
        icon: <HomeSvg />,
        name: <FormattedMessage id="navigation.home" />,
        route: HOME_ROUTE,
        testId: 'programlink',
        permission: 'F_VIEW_COMPANYPROGRAM',
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="navigation.profile" />,
        route: PROFILE_ROUTE,
        testId: 'profilelink',
        permission: 'F_VIEW_MYPROFILE',
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="navigation.people" />,
        route: PEOPLE_ROUTE,
        testId: 'peoplelink',
        permission: 'F_VIEW_USERS',
      },
      {
        icon: <PolicySvg />,
        name: <FormattedMessage id="navigation.policy" />,
        route: POLICY_ROUTE,
        testId: 'policylink',
        permission: 'F_VIEW_POLICIES',
      },
      {
        icon: <SafetySvg />,
        name: <FormattedMessage id="navigation.safety" />,
        route: SAFETY_ROUTE,
        testId: 'safetylink',
        permission: 'F_VIEW_TRIPBOARD',
      },
      {
        icon: <PaymentSvg />,
        name: <FormattedMessage id="navigation.payment" />,
        route: PAYMENT_ROUTE,
        testId: 'paymentlink',
        permission: 'F_VIEW_PAYMENTS',
      },
      {
        icon: <ReportsSvg />,
        name: <FormattedMessage id="navigation.reports" />,
        route: REPORTS_ROUTE,
        testId: 'reportslink',
        permission: 'F_VIEW_REPORTS',
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: SETTINGS_ROUTE,
        testId: 'settingslink',
        permission: 'F_VIEW_COMPANYSETTINGS',
      },
    ],
  },
  AM: {
    adminNavigationItems: [
      {
        icon: <CompaniesSvg />,
        name: <FormattedMessage id="navigation.companies" />,
        route: ADMIN_COMPANIES_ROUTE,
        testId: 'companiesLink',
        permission: 'F_VIEW_PROVIDER_COMPANIES',
        disabledIfMaintenance: true,
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="admin.navigation.people" />,
        route: ADMIN_PEOPLE_ROUTE,
        testId: 'peopleLink',
        permission: 'F_VIEW_PROVIDER_USERS',
        disabledIfMaintenance: true,
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: ADMIN_SETTINGS_ROUTE,
        testId: 'adminsettingslink',
        permission: 'F_PROVIDER_SETTINGS',
        disabledIfMaintenance: false,
      },
    ],
    navigationItems: [
      {
        icon: <ProgramSvg />,
        name: <FormattedMessage id="navigation.program" />,
        route: PROGRAM_ROUTE,
        testId: 'homeLink',
        permission: '',
      },
      {
        icon: <HomeSvg />,
        name: <FormattedMessage id="navigation.home" />,
        route: HOME_ROUTE,
        testId: 'programlink',
        permission: 'F_VIEW_COMPANYPROGRAM',
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="navigation.profile" />,
        route: PROFILE_ROUTE,
        testId: 'profilelink',
        permission: 'F_VIEW_MYPROFILE',
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="navigation.people" />,
        route: PEOPLE_ROUTE,
        testId: 'peoplelink',
        permission: 'F_VIEW_USERS',
      },
      {
        icon: <SafetySvg />,
        name: <FormattedMessage id="navigation.safety" />,
        route: SAFETY_ROUTE,
        testId: 'safetylink',
        permission: 'F_VIEW_TRIPBOARD',
      },
      {
        icon: <PolicySvg />,
        name: <FormattedMessage id="navigation.policy" />,
        route: POLICY_ROUTE,
        testId: 'policylink',
        permission: 'F_VIEW_POLICIES',
      },
      {
        icon: <PaymentSvg />,
        name: <FormattedMessage id="navigation.payment" />,
        route: PAYMENT_ROUTE,
        testId: 'paymentlink',
        permission: 'F_VIEW_PAYMENTS',
      },
      {
        icon: <ReportsSvg />,
        name: <FormattedMessage id="navigation.reports" />,
        route: REPORTS_ROUTE,
        testId: 'reportslink',
        permission: 'F_VIEW_REPORTS',
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: SETTINGS_ROUTE,
        testId: 'settingslink',
        permission: 'F_VIEW_COMPANYSETTINGS',
      },
    ],
  },
  AC: {
    adminNavigationItems: [
      {
        icon: <CompaniesSvg />,
        name: <FormattedMessage id="navigation.companies" />,
        route: ADMIN_COMPANIES_ROUTE,
        testId: 'companiesLink',
        permission: 'F_VIEW_PROVIDER_COMPANIES',
        disabledIfMaintenance: true,
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="admin.navigation.people" />,
        route: ADMIN_PEOPLE_ROUTE,
        testId: 'peopleLink',
        permission: 'F_VIEW_PROVIDER_USERS',
        disabledIfMaintenance: true,
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: ADMIN_SETTINGS_ROUTE,
        testId: 'adminsettingslink',
        permission: 'F_PROVIDER_SETTINGS',
        disabledIfMaintenance: false,
      },
    ],
    navigationItems: [
      {
        icon: <ProgramSvg />,
        name: <FormattedMessage id="navigation.program" />,
        route: PROGRAM_ROUTE,
        testId: 'homeLink',
        permission: '',
      },
      {
        icon: <HomeSvg />,
        name: <FormattedMessage id="navigation.home" />,
        route: HOME_ROUTE,
        testId: 'programlink',
        permission: 'F_VIEW_COMPANYPROGRAM',
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="navigation.profile" />,
        route: PROFILE_ROUTE,
        testId: 'profilelink',
        permission: 'F_VIEW_MYPROFILE',
      },
      {
        icon: <PeopleSvg />,
        name: <FormattedMessage id="navigation.people" />,
        route: PEOPLE_ROUTE,
        testId: 'peoplelink',
        permission: 'F_VIEW_USERS',
      },
      {
        icon: <SafetySvg />,
        name: <FormattedMessage id="navigation.safety" />,
        route: SAFETY_ROUTE,
        testId: 'safetylink',
        permission: 'F_VIEW_TRIPBOARD',
      },
      {
        icon: <PolicySvg />,
        name: <FormattedMessage id="navigation.policy" />,
        route: POLICY_ROUTE,
        testId: 'policylink',
        permission: 'F_VIEW_POLICIES',
      },
      {
        icon: <PaymentSvg />,
        name: <FormattedMessage id="navigation.payment" />,
        route: PAYMENT_ROUTE,
        testId: 'paymentlink',
        permission: 'F_VIEW_PAYMENTS',
      },
      {
        icon: <ReportsSvg />,
        name: <FormattedMessage id="navigation.reports" />,
        route: REPORTS_ROUTE,
        testId: 'reportslink',
        permission: 'F_VIEW_REPORTS',
      },
      {
        icon: <SettingsSvg />,
        name: <FormattedMessage id="navigation.settings" />,
        route: SETTINGS_ROUTE,
        testId: 'settingslink',
        permission: 'F_VIEW_COMPANYSETTINGS',
      },
    ],
  },
};
